import { AUDIENCE, RoomAudience } from '../../../enums/RoomAudience';
import { DENIED_REASON, RoomErrors } from '../../../enums/RoomErrors';
import { Events, Properties } from '../../../enums/Analytics';
import { isVanityUrl } from '../../../lib/helper/RoomHelper';
import { RoomSchema } from '../../../definitions/schemas';
import { RoomStatus } from '../../../enums/RoomStatus';
import { RoomType } from '../../../enums/RoomTypes';
import Analytics, { EventProperty } from '../../../tools/Analytics';

interface TrackingPropertiesParams {
  anonymous?: boolean;
  contactEmail: boolean;
  extended?: boolean;
  referrer: string;
  status?: RoomStatus | 'expired';
}

export const getViewAttemptedEvent = (room: RoomSchema) =>
  room.roomType === RoomType.ContentLink
    ? Events.CONTENT_LINK_ROOM_VIEW_ATTEMPTED
    : Events.DEAL_ROOM_VIEW_ATTEMPTED;

export const getViewedEvent = (room: RoomSchema) =>
  room.roomType === RoomType.ContentLink
    ? Events.CONTENT_LINK_ROOM_VIEWED
    : Events.DEAL_ROOM_VIEWED;

export const getTrackingProperties = (
  room: RoomSchema,
  params: TrackingPropertiesParams
) => {
  let trackingProperties: EventProperty = {
    [Properties.ANONYMOUS_VISITOR]: params.anonymous,
    [Properties.COLLABORATOR_NUMBER]: room.roomCollaborators?.length || 0,
    [Properties.CONTACT_NUMBER]: room.roomContactsCount,
    [Properties.CONTENT_NUMBER]: room.contents?.length,
    [Properties.EMAIL_PARAMETER]: params.contactEmail,
    [Properties.ENABLE_QA]: room.enableQa,
    [Properties.ENTERED_FROM]: params.referrer,
    [Properties.HAS_BANNER]: !!room.bannerUri,
    [Properties.HAS_COMPANY]: !!room.companyId,
    [Properties.HAS_CONTACT_CARD]: room.enableContactCard,
    [Properties.HAS_DEAL]: !!room.deal,
    [Properties.HAS_EMAIL_VERIFICATION]: room.verifyEmail,
    [Properties.HAS_EXPIRATION]: !!room.expiresAt,
    [Properties.HAS_SIGNABLE_DOCUMENT]: !!room.signables?.length,
    [Properties.HAS_WELCOME_MESSAGE]: !!room.welcomeMessage,
    [Properties.ROOM_AUDIENCE]: AUDIENCE[room.audience],
    [Properties.SALES_ACTIONS_NUMBER]: (room.buttons || []).length,
    [Properties.STATUS]: params.status,
    [Properties.VANITY_URL]: isVanityUrl(window.location.origin),
  };

  if (params.extended) {
    trackingProperties = {
      ...trackingProperties,
      [Properties.HAS_EXPLICIT_INVITE]: room.invitedContactsOnly,
      [Properties.HAS_MAP]: !!room.actionPlans?.length,
      [Properties.HAS_PASSCODE]: !!room.requiresPasscode,
      [Properties.HAS_REQUIRES_EMAIL]: room.requiresEmail,
    };
  }

  return trackingProperties;
};

export const trackDeniedAccess = (
  audience: RoomAudience,
  referrer: string,
  reason: string
) => {
  Analytics.track(Events.DEAL_ROOM_EMAIL_DENIED, {
    [Properties.ROOM_AUDIENCE]: AUDIENCE[audience],
    [Properties.ENTERED_FROM]: referrer,
    [Properties.DENY_REASON]: DENIED_REASON[reason as RoomErrors],
  });
};
